export const types = {
  OPEN_DISCOUNT_MODAL: 'modules/quotes/modals/OPEN_DISCOUNT_MODAL',
  CLOSE_DISCOUNT_MODAL: 'modules/quotes/modals/CLOSE_DISCOUNT_MODAL',

  LIVE_DISCOUNT_PREVIEW_REQUEST:
    'modules/quotes/modals/LIVE_DISCOUNT_PREVIEW_REQUEST',
  LIVE_DISCOUNT_PREVIEW_SUCCESS:
    'modules/quotes/modals/LIVE_DISCOUNT_PREVIEW_SUCCESS',
  LIVE_DISCOUNT_PREVIEW_ERROR:
    'modules/quotes/modals/LIVE_DISCOUNT_PREVIEW_ERROR',

  RECEIVE_OVERRIDES: 'modules/quotes/modals/RECEIVE_DISCOUNT_OVERRIDES',
};

export const discountModal = {
  open: ({ cells, isReadOnly, discount }) => {
    return {
      type: types.OPEN_DISCOUNT_MODAL,
      payload: {
        cells,
        isReadOnly,
        discount,
      },
    };
  },
  close: () => ({
    type: types.CLOSE_DISCOUNT_MODAL,
  }),
  receiveOverrides: ({ nextOverrides }) => ({
    type: types.RECEIVE_OVERRIDES,
    payload: { nextOverrides },
  }),
};

export const liveDiscountPreview = {
  request: ({ discountId, newOverrides }) => ({
    type: types.LIVE_DISCOUNT_PREVIEW_REQUEST,
    payload: { discountId, overrides: newOverrides },
  }),
  success: (discount) => ({
    type: types.LIVE_DISCOUNT_PREVIEW_SUCCESS,
    payload: discount,
  }),
  error: () => ({
    type: types.LIVE_DISCOUNT_PREVIEW_ERROR,
  }),
};
